// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"daa4a7dd","201":"62cf1cc3"}[chunkId] + ".chunk.js";
};